import { useState } from "react";

const useLoader = () => {
    const [isLoading, setIsLoading] = useState(false);

    const load = async (...promises) => {
        setIsLoading(true);
        await Promise.all(promises);
        setIsLoading(false);
    };

    return [isLoading, load];
};

export default useLoader;